
import {useContext, useEffect, useRef, useState} from "react";
import {Alert, App, Button, Col, Flex, Input, Row, Statistic} from "antd";
//import { useAuth } from "../hooks/AuthProvider";
import { googleLogout } from '@react-oauth/google';

import loadScript from "../utils/script";
import {appContext} from "../state";
import {Link} from "react-router-dom";
import {isSignedIn} from "../utils/auth";

function Settings(props) {

    const {appStateContextValue} = useContext(appContext);
    const [appState, setAppState] = appStateContextValue
    const [hasSubscriptionManageUrl, setHasSubscriptionManageUrl] = useState('')
    //const [messageApi, contextHolder] = message.useMessage();
    const { message, modal, notification } = App.useApp();

    useEffect(() => {

        hasSubscription().then( () => {})
    }, []);


    function onSignOut () {
        googleLogout()
        localStorage.removeItem('token')
        localStorage.removeItem('app-state')
        window.location.reload()
    }

    function onTest () {
        //message.success( 'Copied to clipboard')
        message.open({type: 'error', content: 'Login failed!'})
       // modal.warning({title: 'This is a warning message', content: 'some messages...some messages...',});
       /* notification.info({
            message: 'Notification topLeft',
            description: 'Hello, Ant Design!!',
            placement: 'topLeft',
        });*/
    }

    async function hasSubscription () {
        const url = process.env.REACT_APP_SERVER_API_HOST+"/user/has-subscription"
        try {
            let headers = new Headers()
            headers.append('Content-Type', 'application/json')
            headers.append("token", localStorage.getItem('token'));
            let requestOptions = {method: 'GET', headers: headers};

            const response = await fetch(url,requestOptions);
            if (!response.ok) {
                console.error(new Error(`Response status: ${response.status}`))
            }
            if (response.status === 200) {
                const json = await response.json();
                console.log('RESPONSE:',json)
                if (json.hasSubscription) {
                    setHasSubscriptionManageUrl(json.manageSubscriptionUrl)
                }
            } else {

            }

        } catch (error) {
            console.error(error.message);
        }
    }

    function onManageMySubscription () {

    }

    function showPricingModal () {
        let newAppState = {...appState}
        newAppState.isPricingModalOpen = true
        setAppState(newAppState)
    }

    function openCheckout () {
        if (!window.LemonSqueezy) {
            return
        }
        console.log('window.LemonSqueezy',window.LemonSqueezy)
        const checkoutUrl = 'https://mocky.lemonsqueezy.com/buy/6e118147-d873-447c-a09e-9986b154361e';
        window.LemonSqueezy.Url.Open(checkoutUrl);
    }

    return (
        <div className="view settings">

            <Flex gap="middle" vertical>
                <Statistic title="Version" value={process.env.REACT_APP_VERSION}/>
                {appState.user?.email ? <Input prefix="Email:" disabled={true} defaultValue={appState.user?.email}></Input> : false}
                {appState.user?.authProvider === 'GOOGLE' ? <div>Logged in via: Google</div> : false}

                <Link to={"/signup"}><Button>Sign up</Button></Link>
                {!isSignedIn(appState) ? <Link to={"/signin"}><Button>Sign in</Button></Link> : false}
                {isSignedIn(appState) ? <Button onClick={onSignOut}>Sign out</Button> : false}
                {hasSubscriptionManageUrl !== '' ? <a target="_blank" href={hasSubscriptionManageUrl}><Button>Manage
                    my subscription</Button></a> :false}

                {/*<Button onClick={openCheckout}>Buy</Button>*/}
                {<a target="_blank" href={process.env.REACT_APP_LANDING_PAGE+"/pricing"}><Button>Upgrade</Button></a>}
                {process.env.REACT_APP_ENV !== 'PRODUCTION' ? <Button onClick={onTest}>Test</Button> : false}
                {/*process.env.REACT_APP_ENV !== 'PRODUCTION' ?  <Button onClick={showPricingModal}>Buy</Button> : false*/}

                <Alert
                    message="Subscriptions"
                    description="When purchasing a subscription please use the same email that you used for creating your account."
                    type="info"
                    showIcon
                />


            </Flex>
        </div>
    );
}

export default Settings;
